import { connect } from 'react-redux'
import { getUserDto, getUserCompanies, hasRoleInCompany } from '../../common/auth/authSelectors'
import { IGlobalState } from '../../Root/store/appReducer'
import {
  getCurrentCompanyGoal,
  getCurrentGoalActivityList,
  setActivityView,
} from '../../views/Activity/store/ActivityActions'
import {
  getActivityFilter,
  getActivityView,
  getGroupView,
  getGroupSum,
} from '../../views/Activity/store/ActivitySelectors'
import { YumGoalRanking, IDispatchProps, IStateProps } from './YumGoalRanking'
import { companyDivisionsSelector, companyCountriesSelector } from '../../views/Settings/store/SettingsSelectors'
import { CompanyId, GoalWithProgress, Role } from '../../services/api.types'
import {
  getCustomProgressSelector,
  getDailyProgressSelector,
  getLastBonusPointsAdded,
  getProgressResultsSelector,
} from '../../views/Progress/store/progressSelectors'
import { getDivisionCategories } from '../../views/TeamManagement/store/TeamManagementSelectors'
import { getDivisionCategories as getDivisionCategoriesAction } from '../../views/TeamManagement/store/TeamManagementActions'
import { getCompanyDivisions } from '../../views/Settings/store/SettingsActions'
import { getCustomTypeWithLegacy } from '../../services/CustomTypes'

export interface IOwnProps {
  goalDto: GoalWithProgress
  token?: string
  isLegacyRanking: boolean
}

const mapStateToProps = (state: IGlobalState, ownProps: IOwnProps): IStateProps => {
  const { goalDto, token, isLegacyRanking } = ownProps
  const { id: goalId, customType, progressType } = goalDto
  return {
    hasRoleInCompany: (companyId: CompanyId, role: Role) => hasRoleInCompany(state, companyId, role),
    goalDto,
    userDto: getUserDto(state),
    userCompanies: getUserCompanies(state),
    activityView: getActivityView(state, goalId),
    activityFilter: getActivityFilter(state, goalId),
    groupView: getGroupView(state, goalId),
    groupSum: getGroupSum(state, goalId),
    divisions: companyDivisionsSelector(state),
    countries: companyCountriesSelector(state),
    divisionCategories: getDivisionCategories(state),
    lastBonusPointsAdded: getLastBonusPointsAdded(state),
    token,
    isLegacyRanking,
    dailyDiary: getDailyProgressSelector(state, getCustomTypeWithLegacy(customType, progressType)),
    customProgress: getCustomProgressSelector(state, goalId),
    progressResults: getProgressResultsSelector(state),
  }
}

const mapDispatchToProps: IDispatchProps = {
  setActivityView,
  getCurrentGoalActivityList,
  getCurrentCompanyGoal,
  getDivisionCategories: getDivisionCategoriesAction,
  getCompanyDivisions,
}

export default connect(mapStateToProps, mapDispatchToProps)(YumGoalRanking)
